export const fetchImageAsFile = async (
  url: string,
  name: string,
): Promise<File> => {
  const response = await fetch(url)
  const blob = await response.blob()
  return new File([blob], name, { type: blob.type })
}
